import styled from 'styled-components'

export const AvailabilityModalContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: clamp(32rem, 68vh, 74rem);

  @media (max-width: 1100px) {
    min-height: auto;
  }
`

export const AvailabilityModalHero = styled.div`
  display: flex;
  gap: 5%;
  align-items: center;
`

export const AvailabilityModalMedia = styled.div`
  flex: 0 0 30%;
  overflow: hidden;
  max-width: 25%;
  aspect-ratio: 1 / 1;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 1100px) {
    width: 100%;
    min-width: 0;
    max-width: none;
  }
`

export const AvailabilityModalInfo = styled.div`
  h3 {
    font-family: ${props => props.theme.font.primary};
    font-weight: 600;
    font-size: 2rem;
    line-height: 1.1;
    margin-bottom: 0.25rem;
  }

  .description-preview {
    margin-top: 0.45rem;
    max-width: 34rem;
  }
`

export const AvailabilityModalDivider = styled.hr`
  border: 0;
  border-top: 1px solid ${props => props.theme.color.line};
  margin: 3rem 0;
`

export const AvailabilityModalSlotsSection = styled.div``

export const AvailabilityModalSlotsTitle = styled.h4`
  text-align: center;
  font-size: 1.4rem;
  line-height: 1.1;
  margin-bottom: 2rem;
`

export const AvailabilityModalSlots = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.9rem;
  max-width: 96rem;
  margin: 0 auto;
`

export const AvailabilityModalFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`

export const AvailabilityModalSelection = styled.div`
  display: inline-flex;
  align-items: center;
  font-size: 1.1rem;
  color: ${props => props.theme.color.muted};
  margin-left: auto;

  strong {
    color: ${props => props.theme.color.global};
    margin-left: 0.75rem;
    font-size: 1.2em;
    font-weight: 500;
  }
`
